import React from "react";
import PropTypes from "prop-types";
import { Container } from "../components/simple";

import { paramsToObject } from "../api/params";
import * as routes from "../router/routes";

import "../styles/shared/unauthed.scss";

export default function StartScreen(props) {
  const {
    location: { search },
    history
  } = props;
  const searchQuery = paramsToObject(search);
  if (searchQuery.login) {
    history.replace(routes.signIn);
  }
  // else if (searchQuery.signup) {
  //   history.replace(routes.signUp);
  // }
  else history.replace(routes.signIn);
  return <Container className="unauthed-container-background" fluid />;
}

StartScreen.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func
  }).isRequired
};
